import {useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent, ScrollComponent, ToggleComponent} from '../../../assets/ts/components'
import {SidebarGroupsProvider} from './SidebarGroups'
import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {
  const {pathname} = useLocation()

  // MasterInit bootstraps Metronic's components once, ~500ms after the app mounts — usually
  // before login has rendered this layout. Re-create the sidebar drawer (mobile), the minimize
  // toggle and the menu scroller here; all three createInstances calls skip existing instances.
  useEffect(() => {
    const timer = setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
    }, 50)
    return () => clearTimeout(timer)
  }, [pathname])

  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded fw-semibold px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
        >
          <SidebarGroupsProvider>
            <SidebarMenuMain />
          </SidebarGroupsProvider>
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
